import { render, staticRenderFns } from "./ProductActionDropdown.vue?vue&type=template&id=24eac43b&lang=pug"
import script from "./ProductActionDropdown.vue?vue&type=script&lang=js"
export * from "./ProductActionDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports